import React, { Component } from "react";
import Swal from 'sweetalert2';
import LoginCode from "./loginCode";
import { enqueueSnackbar } from "notistack";
import Cookies from 'js-cookie';

class VoteSave extends Component {
    state = {
        showCodeModal: false,
        verificationCode: '',
        votesToSubmit: null
    };

    parseNumber = (value) => {
        const stringValue = typeof value === 'number' ? value.toString() : value;
        if (typeof stringValue === 'string') {
            if (stringValue.includes(' ')) {
                const [whole, fraction] = stringValue.split(' ');
                const [numerator, denominator] = fraction.split('/');
                return {
                    Quantity: parseInt(whole, 10),
                    Numerator: parseInt(numerator, 10),
                    Denominator: parseInt(denominator, 10)
                };
            } else if (stringValue.includes('/')) {
                const [numerator, denominator] = stringValue.split('/');
                return {
                    Numerator: parseInt(numerator, 10),
                    Denominator: parseInt(denominator, 10)
                };
            } else if (stringValue.includes('.')) {
                const [whole, decimal] = stringValue.split('.');
                const numerator = parseInt(decimal, 10);
                const denominator = Math.pow(10, decimal.length);
                const gcd = this.greatestCommonDivisor(numerator, denominator);
                return {
                    Quantity: parseInt(whole, 10),
                    Numerator: numerator / gcd,
                    Denominator: denominator / gcd
                };
            }
        }
        return {
            Quantity: parseInt(stringValue, 10)
        };
    }

    greatestCommonDivisor = (a, b) => {
        if (b === 0) return a;
        return this.greatestCommonDivisor(b, a % b);
    }

    formatVoteData = (votes) => {
        let voteDetails = {
            VoteDtls: {
                VoteInstrForAgndRsltn: []
            }
        };
        for (const [key, value] of Object.entries(votes)) {
            const questionId = parseInt(key);
            if (Array.isArray(value)) {
                const [voteType, quantity] = value;
                const parsedNumber = this.parseNumber(quantity);
                const voteInstr = {
                    VoteInstr: {
                        [voteType === 'За' ? 'For' : voteType === 'Против' ? 'Against' : 'Abstn']: parsedNumber,
                        QuestionId: questionId
                    }
                };
                voteDetails.VoteDtls.VoteInstrForAgndRsltn.push(voteInstr);
            } else if (typeof value === 'object' && value !== null) {
                if (value.cumulative === 'cumulative') {
                    for (const [detailId, quantity] of Object.entries(value)) {
                        if (detailId !== 'undefined' && detailId !== 'cumulative') {
                            const parsedNumber = this.parseNumber(quantity);
                            const voteInstr = {
                                VoteInstr: {
                                    For: parsedNumber,
                                    DetailId: parseInt(detailId),
                                    QuestionId: questionId
                                }
                            };
                            voteDetails.VoteDtls.VoteInstrForAgndRsltn.push(voteInstr);
                        }
                    }
                } else {
                    for (const [detailId, detailValue] of Object.entries(value)) {
                        if (detailId !== 'undefined') {
                            const [voteType, quantity] = detailValue;
                            const parsedNumber = this.parseNumber(quantity);
                            const voteInstr = {
                                VoteInstr: {
                                    [voteType === 'За' ? 'For' : voteType === 'Против' ? 'Against' : 'Abstn']: parsedNumber,
                                    DetailId: parseInt(detailId),
                                    QuestionId: questionId
                                }
                            };
                            voteDetails.VoteDtls.VoteInstrForAgndRsltn.push(voteInstr);
                        }
                    }
                }
            }
        }
        return voteDetails;
    }

    sendVerificationCode = async () => {
    const csrftoken = Cookies.get('csrftoken');

    // Показываем модальное окно с анимацией загрузки
    Swal.fire({
        title: 'Отправка кода подтверждения...',
        html: 'Пожалуйста, подождите.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    try {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const response = await fetch(`${API_ADDRESS}login_code_result/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken,
            },
            body: JSON.stringify({ email: this.props.userEmail })
        });

        const data = await response.json();

        if (Swal.isVisible()) {
            Swal.close();
        }

        if (response.ok) {
            this.setState({
                showCodeModal: true,
                verificationCode: data.code
            });
        } else {
            enqueueSnackbar('Ошибка при отправке кода', { variant: 'error' });
        }
    } catch (error) {
        if (Swal.isVisible()) {
            Swal.close();
        }

        console.error('Error:', error);
        enqueueSnackbar('Ошибка, обратитесь к администратору', { variant: 'error' });
    }
};

    verifyCode = async (inputCode) => {
        const fullCode = this.state.verificationCode;
        const actualCode = fullCode.substring(13, 18);

        if (inputCode === actualCode) {
            this.setState({ showCodeModal: false }, () => {
                this.submitVotes();
            });
        } else {
            enqueueSnackbar('Неверный код подтверждения', { variant: 'error' });
        }
    };

    submitVotes = () => {
        const formattedData = this.formatVoteData(this.state.votesToSubmit);
        const { meeting, selectedAccountId, selectedUniquifier } = this.props;
        const meetingId = meeting.meeting_id;
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        fetch(`${API_ADDRESS}save_meeting_res/${meetingId}/${selectedAccountId}/${selectedUniquifier}/`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ Result: formattedData })
        })
        .then(response => {
            if (!response.ok) throw new Error('Ошибка при сохранении голосования');
            return response.json();
        })
        .then(data => {
            Swal.close();
            if (data.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Ошибка',
                    text: data.error,
                    confirmButtonText: 'Ок',
                    customClass: {
                        confirmButton: 'confirm-button'
                    }
                }).then(() => {
                    this.props.onVoteSubmitted();
                    window.history.back();
                });
            } else {
                Swal.fire({
                    icon: 'success',
                    title: 'Вы успешно проголосовали !',
                    confirmButtonText: 'Ок',
                    customClass: {
                        confirmButton: 'confirm-button'
                    }
                }).then(() => {
                    document.body.style.overflow = '';
                    this.props.onVoteSubmitted();
                    window.history.back();
                });
            }
        })
        .catch((error) => {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Произошла ошибка',
                text: 'Не удалось сохранить результаты голосования',
                confirmButtonText: 'Ок',
                customClass: {
                    confirmButton: 'confirm-button'
                }
            }).then(() => {
                if (this.props.unblock) {
                    this.props.unblock();
                }
                document.body.style.overflow = '';
                window.history.back();
            });
        });
    };

    handleSave = () => {
        document.body.style.overflow = 'hidden'; // Блокируем скролл при открытии первого модального окна
        //console.log('row votes:', this.props.votes);

        Swal.fire({
            title: 'Уважаемый акционер',
            html: '<u><b>Вы успешно заполнили бюллетень по всем вопросам повестки дня собрания</b></u>',
            showCancelButton: true,
            confirmButtonText: 'Далее',
            cancelButtonText: 'Отмена',
            customClass: {
                confirmButton: 'confirm-button',
                cancelButton: 'cancel-button'
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                document.body.style.overflow = '';
            }

            if (result.isConfirmed) {
                let checkboxChecked = false;

                const checkboxHtml = `
                    <div style="margin-top: 20px; display: flex; align-items: center; justify-content: center;">
                        <label style="display: flex; align-items: center; cursor: pointer;">
                            <input type="checkbox" id="confirmCheckbox" style="margin-right: 10px;" />
                            Я подтверждаю, что завершил голосование
                        </label>
                    </div>
                `;

                Swal.fire({
                    title: 'Для этой операции требуется подтверждение',
                    icon: 'warning',
                    html: `
                        <div style="text-align: center;">
                            На вашу почту <strong>${this.props.userEmail}</strong> будет отправлен код подтверждения<br />
                            ${checkboxHtml}
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Подтвердить',
                    cancelButtonText: 'Отмена',
                    focusConfirm: false,
                    customClass: {
                        confirmButton: 'confirm-button',
                        cancelButton: 'cancel-button'
                    },
                    didOpen: () => {
                        const checkbox = Swal.getPopup().querySelector('#confirmCheckbox');
                        const confirmBtn = Swal.getConfirmButton();
                        confirmBtn.disabled = true;

                        checkbox.addEventListener('change', () => {
                            checkboxChecked = checkbox.checked;
                            confirmBtn.disabled = !checkboxChecked;
                        });
                    },
                    preConfirm: () => {
                        if (!checkboxChecked) {
                            Swal.showValidationMessage('Необходимо подтвердить голосование');
                        }
                    }
                }).then((secondResult) => {
                    if (secondResult.dismiss === Swal.DismissReason.cancel) {
                        document.body.style.overflow = '';
                    }

                    if (secondResult.isConfirmed) {
                        this.setState({ votesToSubmit: this.props.votes }, () => {
                            this.sendVerificationCode();
                        });
                    }
                });
            }
        });
    };

    closeModal = () => {
        this.setState({
            showCodeModal: false
        }, () => {
            document.body.style.overflow = '';
        });
    };

    render() {
        const { showCodeModal } = this.state;
        return (
            <>
                <div className="button-container5">
                    <button2
                        className={`button2`}
                        style={{ margin: '0 auto' }}
                        onClick={this.handleSave}
                    >
                        <b>Подтвердить</b>
                    </button2>
                </div>

                {/* Модальное окно для ввода кода */}
                {showCodeModal && (
                    <LoginCode
                        isCodeValid={false}
                        verifyCode={this.verifyCode}
                        onClose={this.closeModal}
                    />
                )}
            </>
        );
    }
}

export default VoteSave;